import { GridColumns } from '@iv/shared/components/grid/grid-column';

export const advancedSearchGridColumns: GridColumns = {
  'checkbox': {
    'dataField': 'checkbox',
    'visible': true,
    'type': 'checkbox',
    'template': 'checkbox',
    'minWidth': 35,
    'width': 35,
    'widthCoefficient': 0,
    'description': ''
  },
  'symbol': {
    'dataField': 'symbol',
    'visible': true,
    'caption': 'Symbol',
    'template': 'symbol',
    'minWidth': 45,
    'width': 45,
    'widthCoefficient': 2,
    'description': ''
  },
  'company': {
    'dataField': 'company',
    'visible': true,
    'caption': 'Company Name',
    'template': 'text',
    'minWidth': 150,
    'width': 150,
    'widthCoefficient': 6,
    'description': ''
  },
  'exchange': {
    'dataField': 'exchange',
    'visible': true,
    'caption': 'Exchange',
    'template': 'text',
    'minWidth': 70,
    'width': 70,
    'widthCoefficient': 3,
    'description': ''
  },
  'region': {
    'dataField': 'region',
    'visible': true,
    'caption': 'Market',
    'template': 'text',
    'minWidth': 70,
    'width': 70,
    'widthCoefficient': 3,
    'description': ''
  }
};
